var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import linker from '../linker';
import showError from '../central/showError';
import { NewsService } from '../services/NewsService';
import { TermNaviService } from '../services/TermNaviService';
var CategoryHeader = (function (_super) {
    __extends(CategoryHeader, _super);
    function CategoryHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.term = null;
        _this.news = null;
        return _this;
    }
    CategoryHeader.prototype.mounted = function () {
        this.load();
    };
    CategoryHeader.prototype.load = function () {
        var _this = this;
        if (SP.Guid.isValid(this.termSetId)) {
            var srv_1 = TermNaviService.start(this.termSetId);
            var termPath = srv_1.getCurrentTermPath();
            srv_1.loadTermItem(termPath).then(function (term) {
                if (term) {
                    _this.term = term;
                    if (!_this.term.icon) {
                        srv_1.loadTermCustomPropertyDescByTermId(term.id, 'SVG').then(function (icon) { return _this.term.icon = icon; });
                    }
                    new NewsService().loadLastestNewsOfCategory(term).then(function (news) {
                        _this.news = news;
                    });
                }
            });
        }
        else {
            showError('CategoryNaviTermSetId in Portalkonfiguration ist nicht gesetzt!');
        }
    };
    __decorate([
        Prop({ type: String })
    ], CategoryHeader.prototype, "termSetId", void 0);
    CategoryHeader = __decorate([
        Component({})
    ], CategoryHeader);
    return CategoryHeader;
}(Vue));
export default CategoryHeader;
linker.register('categoryHeader', CategoryHeader);
